'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.use = exports.combine = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _IoT = require('./IoT');

var combine = function combine(countryList) {
    var regions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var result = _extends({}, countryList);

    Object.keys(regions).forEach(function (iso1) {
        result[iso1].regions = regions[iso1];
    });

    return result;
};

var use = function use(dataset) {
    return (0, _IoT.setDataFile)(dataset);
};

exports.combine = combine;
exports.use = use;